import {
  Cog6ToothIcon,
  CurrencyDollarIcon,
  MapIcon,
  PhoneIcon,
  TruckIcon,
} from "@heroicons/react/24/outline";

export const INTEGRATION_CATALOG = [
  {
    key: "tripletex",
    icon: Cog6ToothIcon,
    requiredFields: ["tripletex_employee_token"],
    fields: [
      { name: "tripletex_employee_token", secret: true, labelKey: "company.integrations.fields.tripletex_employee_token" },
      {
        name: "tripletex_hour_sync_if_approved_only",
        type: "switch",
        labelKey: "company.integrations.fields.tripletex_hour_sync_if_approved_only",
      },
    ],
  },
  {
    key: "bring",
    icon: TruckIcon,
    requiredFields: ["bring_api_uid", "bring_api_key"],
    fields: [
      { name: "bring_api_uid", labelKey: "company.integrations.fields.bring_api_uid" },
      { name: "bring_api_key", secret: true, labelKey: "company.integrations.fields.bring_api_key" },
      { name: "bring_main_customer_number", labelKey: "company.integrations.fields.bring_main_customer_number" },
    ],
  },
  {
    key: "stripe",
    icon: CurrencyDollarIcon,
    requiredFields: ["stripe_secret_key"],
    fields: [
      { name: "stripe_webhook_secret", secret: true, labelKey: "company.integrations.fields.stripe_webhook_secret" },
      { name: "stripe_webhook_url", disabled: true, labelKey: "company.integrations.fields.stripe_webhook_url" },
      { name: "stripe_secret_key", secret: true, labelKey: "company.integrations.fields.stripe_secret_key" },
    ],
  },
  {
    key: "automile",
    icon: Cog6ToothIcon,
    requiredFields: ["automile_client_id", "automile_client_secret"],
    fields: [
      { name: "automile_client_id", labelKey: "company.integrations.fields.automile_client_id" },
      { name: "automile_client_secret", secret: true, labelKey: "company.integrations.fields.automile_client_secret" },
      { name: "automile_username", labelKey: "company.integrations.fields.automile_username" },
      { name: "automile_password", type: "password", secret: true, labelKey: "company.integrations.fields.automile_password" },
    ],
  },
  {
    key: "google_maps",
    icon: MapIcon,
    requiredFields: ["google_maps_api_key"],
    fields: [
      { name: "google_maps_api_key", secret: true, labelKey: "company.integrations.fields.google_maps_api_key" },
    ],
  },
  {
    key: "webshop",
    icon: CurrencyDollarIcon,
    requiredFields: ["webshop_products_url"],
    fields: [
      { name: "store_checkout_active", type: "switch", labelKey: "company.integrations.fields.store_checkout_active" },
      { name: "webshop_products_url", labelKey: "company.integrations.fields.webshop_products_url" },
      { name: "webshop_order_cancel_url", labelKey: "company.integrations.fields.webshop_order_cancel_url" },
      { name: "webshop_order_success_url", labelKey: "company.integrations.fields.webshop_order_success_url" },
    ],
  },
  {
    key: "phonero",
    icon: PhoneIcon,
    requiredFields: ["phonero_username", "phonero_password"],
    fields: [
      { name: "phonero_username", labelKey: "company.integrations.fields.phonero_username" },
      { name: "phonero_password", type: "password", secret: true, labelKey: "company.integrations.fields.phonero_password" },
      { name: "phonero_customer_id", labelKey: "company.integrations.fields.phonero_customer_id" },
    ],
  },
];

export function isIntegrationConnected(item, company) {
  return item.requiredFields.every((field) => Boolean(company?.[field]));
}

export function catalogWithCompanyValues(company) {
  return INTEGRATION_CATALOG.map((item) => ({
    ...item,
    connected: isIntegrationConnected(item, company),
    initialFormValues: item.fields.map((field) => ({
      ...field,
      value: company?.[field.name],
    })),
  }));
}
